import type { Theme } from '@mui/material';

export const uakdoControllerControlSectionStyles = {
  fieldsStack: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  }),
  topRow: (theme: Theme) => ({
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      md: 'repeat(2, minmax(0, 1fr))',
    },
    gap: theme.spacing(1.5),
    alignItems: 'start',
  }),
  fullWidthField: {
    width: '100%',
  },
  readOnlyField: (theme: Theme) => ({
    width: '100%',
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.common.white,
      opacity: 1,
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: theme.palette.common.white,
      opacity: 1,
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: theme.palette.common.white,
      opacity: 1,
    },
    '& .MuiInputBase-input.Mui-disabled, & .MuiInputBase-inputMultiline.Mui-disabled, & .MuiOutlinedInput-input.Mui-disabled, & textarea.MuiInputBase-input.Mui-disabled': {
      color: theme.palette.text.primary,
      WebkitTextFillColor: theme.palette.text.primary,
      opacity: 1,
    },
    '& textarea.Mui-disabled': {
      color: theme.palette.text.primary,
      WebkitTextFillColor: theme.palette.text.primary,
      opacity: 1,
    },
    '& .MuiAutocomplete-popupIndicator.Mui-disabled, & .MuiAutocomplete-clearIndicator.Mui-disabled': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
  }),
  rejectButton: (theme: Theme) => ({
    minHeight: 44,
    padding: '10px 24px',
    borderRadius: '8px',
    fontSize: '0.9375rem',
    lineHeight: 1.2,
    fontWeight: 500,
    textTransform: 'none',
    boxShadow: 'none',
    whiteSpace: 'nowrap',
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      backgroundColor: theme.palette.action.hover,
    },
  }),
} as const;
